export const formats = "image/jpeg, image/png, application/pdf";


// WEBPACK FOOTER //
// ./src/components/fileUploadAllowedFormats.js